import { createReducer, on } from "@ngrx/store";
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";

import { contextPanelActions } from "@store/doc-viewer/context-panel/context-panel.actions";

export const contextPanelReducer = createReducer<DocViewerState['currentContextPanelView']>(
	'browse',
	on(contextPanelActions.setContextPanel, (_state, {selectedContext}) => {
		return selectedContext;
	}),
);
